import React, { useEffect, useState } from 'react';
import { ShoppingBag, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['María L.', 'Carolina M.', 'Lucía R.', 'Florencia G.', 'Agustina P.', 'Valentina S.', 'Camila T.', 'Sofía B.', 'Martina F.', 'Julieta C.', 'Victoria D.', 'Micaela N.'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Neuquén', 'Bahía Blanca', 'San Juan', 'Resistencia'];
export function RecentPurchasePopup() {
  const [show, setShow] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 8) + 1;
      setCurrentPurchase({
        name: randomName,
        city: randomCity,
        time: `hace ${randomTime} minutos`
      });
      setShow(true);
      setTimeout(() => setShow(false), 6000);
    };
    const interval = setInterval(showPopup, 15000);
    setTimeout(showPopup, 3000);
    return () => clearInterval(interval);
  }, []);
  return <AnimatePresence data-id="element-231">
      {show && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-6 left-6 z-50 max-w-sm" data-id="element-232">
          <div className="bg-white rounded-2xl shadow-2xl border-2 border-emerald-200 p-4 flex items-start gap-4" data-id="element-233">
            <div className="bg-emerald-100 rounded-full p-3 flex-shrink-0" data-id="element-234">
              <ShoppingBag className="w-6 h-6 text-emerald-600" data-id="element-235" />
            </div>
            <div className="flex-1" data-id="element-236">
              <div className="font-bold text-slate-900 mb-1" data-id="element-237">
                {currentPurchase.name} acaba de comprar
              </div>
              <div className="text-sm text-slate-600" data-id="element-238">
                desde {currentPurchase.city} · {currentPurchase.time}
              </div>
            </div>
            <button onClick={() => setShow(false)} className="text-slate-400 hover:text-slate-600 flex-shrink-0" data-id="element-239">
              <X className="w-5 h-5" data-id="element-240" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}